import React from "react";
import { CategoryHierarchy } from "@Interfaces/Api/category";
import Category from "./Category";
import { StyledCategoriesContainer } from "@Styled/Layout/header";

const Categories = ({
  categoryHierarchy,
}: {
  categoryHierarchy: CategoryHierarchy[];
}) => {
  return (
    <>
      {/* <MobileCategoryHeader allRootCategories={categoryHierarchy} /> */}
      {categoryHierarchy.map((parentCategory) => (
        <Category key={parentCategory._id} category={parentCategory} />
      ))}
    </>
  );
};

export default Categories;
